<template>
    <div class="user-wapper p-5">
        <h5 class="titleUnderline mt-2 mb-4 ">Invitar Usuario</h5>
        <b-form @submit.prevent="onSubmit" class="my-3">
            <b-form-group label="Usuario">
                <b-input v-model="username" />
            </b-form-group>
            <b-form-group label="Correo Electrónico" class="my-3">
                <b-input v-model="email" />
            </b-form-group>
            <cid-button type="submit" variant="primary" class="my-3">Invitar</cid-button>
        </b-form>
        <b-spinner v-if="isLoading" />
        <p v-if="success" class="text-success">Invitación enviada correctamente</p>
        <p v-if="error" class="text-danger">Error al enviar la invitación</p>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'InviteUser',
        data() {
            return {
                email: '',
                username: '',
                companyname: 'Zertifika',
                isLoading: false,
                success: false,
                error: false,
            };
        },
        methods: {
            onSubmit() {
                this.isLoading = true;
                this.error = false;

                // Enviar la invitación al servidor
                axios.post('/api/Invitation/InviteUser/', {
                    username: this.username,
                    email: this.email,
                    companyname: this.companyname,
                })
                    .then(() => {
                        this.success = true;
                    })
                    .catch(() => {
                        this.error = true;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
        },
    };
</script>





<style scoped>
    .user-wapper {
        margin: 10px;
        padding: 25px 15px;
        background: #ffffff;
        background-color: #ffffff;
        color: #333333;
        border: 1px solid #dddddd;
        border-radius: 4px;
    }

    .file-iconstack {
        margin: 0;
    }

        .file-iconstack .b-icon {
            margin-right: 4px;
            /* Espaciado entre los iconos */
            width: 0.5em;
        }

    .chart {
        display: flex;
        width: 40px;
        height: 20px;
        justify-content: space-between;
        flex-direction: row;
        align-items: flex-end;
    }

    .bar {
        width: 100%;
        border-radius: 1.5px 1.5px 0px 0px;
        margin-right: 5px;
    }

        .bar:last-child {
            margin-right: 0;
        }
</style>